// extracted by mini-css-extract-plugin
export default {"page":"NavbarBweb_page_Ud96X","selected":"NavbarBweb_selected_ZiysQ"};